import React, { Component } from 'react';

import './app.css';
import { Main } from '../main/Main';

export class App extends Component {
  render() {
    return (
      <div className="app">
        <Main />
      </div>
    );
  }
}
